export class Events {
    constructor() {
        this.bus = document.createElement('div');
    }
    on(event, callback) {
        if (event === 'loaded' && document.readyState === 'complete') {
            callback.call(this);
            return;
        }
        this.bus.addEventListener(event, callback);
    }
    off(event, callback) {
        this.bus.removeEventListener(event, callback);
    }
    emit(event, payload = {}) {
        this.bus.dispatchEvent(new CustomEvent(event, {
            detail: payload
        }));
    }
}
export const Bus = new Events();
export default Bus;
